import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import ReactMarkdown from 'react-markdown';
import RemarkBreaks from 'remark-breaks';
import RemarkGFM from 'remark-gfm';
import { Text } from '@hub/text';
import { Box } from '@hub/box';
import { Link } from '@hub/link';
import { markdownStyle } from './styles';
import { CloudinaryImage } from '../cloudinary-image';
import { getYoutubeUrlDetails } from '../../helpers/youtube-url';
import YoutubeLink from '../../components/youtube-link';
import { H1, H2, H3, H4, H5, H6 } from '@hub/heading';
import { ListItem, OrderedList, UnorderedList } from '@hub/list';
import { jsx as _jsx } from "react/jsx-runtime";
const DEFAULT_MARKDOWN_IMAGE_WIDTH = '1200';
const link = _ref => {
  let {
    title,
    href = '',
    children
  } = _ref;
  const youtubeDetails = getYoutubeUrlDetails(href);
  if (youtubeDetails) {
    return /*#__PURE__*/_jsx(YoutubeLink, _objectSpread(_objectSpread({
      title: title
    }, youtubeDetails), {}, {
      "data-id": "markdown_index_link_YoutubeLink"
    }));
  }
  if (/^(https:\/\/[^/]+)?\/shop\/(brand|collection|product)/.test(href)) {
    return children;
  }
  if (/^(https:\/\/[^/]+)?\/shop\/info\/(click-and-collect|delivery)/.test(href)) {
    return children;
  }
  return /*#__PURE__*/_jsx(Link, {
    href: href || '',
    title: title,
    isExternal: true,
    target: "_blank",
    rel: "noopener noreferrer",
    "data-id": "markdown_index_link_Link",
    children: children
  });
};
export const Markdown = _ref2 => {
  let {
    content,
    components,
    wrapperClass,
    sx,
    dataTestId
  } = _ref2;
  return /*#__PURE__*/_jsx(Box, {
    className: wrapperClass,
    "data-test-id": dataTestId,
    sx: _objectSpread(_objectSpread({}, markdownStyle), sx),
    "data-id": "markdown_index_link_Box",
    children: /*#__PURE__*/_jsx(ReactMarkdown, {
      skipHtml: true
      // eslint-disable-next-line react/no-children-prop
      ,
      children: content || '',
      plugins: [RemarkBreaks, RemarkGFM],
      components: _objectSpread({
        a: link,
        p: _ref3 => {
          let {
            children
          } = _ref3;
          return /*#__PURE__*/_jsx(Text, {
            isBodyText: true,
            sx: {
              color: 'undefined'
            },
            "data-id": "markdown_index_link_Text",
            children: children
          });
        },
        h1: _ref4 => {
          let {
            children
          } = _ref4;
          return /*#__PURE__*/_jsx(H1, {
            "data-id": "markdown_index_link_H1",
            children: children
          });
        },
        h2: _ref5 => {
          let {
            children
          } = _ref5;
          return /*#__PURE__*/_jsx(H2, {
            "data-id": "markdown_index_link_H2",
            children: children
          });
        },
        h3: _ref6 => {
          let {
            children
          } = _ref6;
          return /*#__PURE__*/_jsx(H3, {
            "data-id": "markdown_index_link_H3",
            children: children
          });
        },
        h4: _ref7 => {
          let {
            children
          } = _ref7;
          return /*#__PURE__*/_jsx(H4, {
            "data-id": "markdown_index_link_H4",
            children: children
          });
        },
        h5: _ref8 => {
          let {
            children
          } = _ref8;
          return /*#__PURE__*/_jsx(H5, {
            "data-id": "markdown_index_link_H5",
            children: children
          });
        },
        h6: _ref9 => {
          let {
            children
          } = _ref9;
          return /*#__PURE__*/_jsx(H6, {
            "data-id": "markdown_index_link_H6",
            children: children
          });
        },
        ul: _ref10 => {
          let {
            children
          } = _ref10;
          return /*#__PURE__*/_jsx(UnorderedList, {
            "data-id": "markdown_index_link_UnorderedList",
            children: children
          });
        },
        ol: _ref11 => {
          let {
            children
          } = _ref11;
          return /*#__PURE__*/_jsx(OrderedList, {
            "data-id": "markdown_index_link_OrderedList",
            children: children
          });
        },
        li: _ref12 => {
          let {
            children
          } = _ref12;
          return /*#__PURE__*/_jsx(ListItem, {
            "data-id": "markdown_index_link_ListItem",
            children: children
          });
        },
        th: _ref13 => {
          let {
            children
          } = _ref13;
          return /*#__PURE__*/_jsx("th", {
            "data-id": "markdown_index_link_th",
            children: /*#__PURE__*/_jsx(H4, {
              sx: {
                fontSize: 'font-lg',
                lineHeight: 'base'
              },
              "data-id": "markdown_index_link_th_H4",
              children: children
            })
          });
        },
        img: _ref14 => {
          let {
            src,
            alt
          } = _ref14;
          return /*#__PURE__*/_jsx(CloudinaryImage, {
            imageSetOrImage: {
              url: String(src),
              type: 'SQUARE',
              alt
            },
            maxWidth: DEFAULT_MARKDOWN_IMAGE_WIDTH,
            "data-id": "markdown_index_link_CloudinaryImage"
          });
        }
      }, components),
      "data-id": "markdown_index_link_Box_ReactMarkdown"
    })
  });
};